export const CHECKOUT_URL = 'https://transplant-en.impultienda.ar/checkout/';

export const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/4Y5mwZUt2xRsAUwbbYrvM7/MOCKUP_TRANSPLANT-EN.png';
export const AUTHOR_IMAGE = 'https://cdn.magicpatterns.com/uploads/dJSsvcJxpnuFsW8jFjGbLq/Dr._Daniel_Mitchell_-_TRANSPLANT.png';

export const SPOTS_LEFT = 7;
export const SPOTS_FILLED_PERCENT = 93;

export const introIncludes = [
  '6 specialized educational volumes.',
  '5 exclusive professional bonuses.',
  'Patient assessment frameworks.',
  'Follicular unit anatomy references.',
  'Hairline design educational materials.',
  'Donor area assessment resources.',
  'Clinical documentation templates.',
  'Educational case studies.',
  'Follow-up worksheets.',
];

export const priceIncludes = [
  'Six specialized educational volumes.',
  'Five professional bonuses.',
  'Patient assessment frameworks.',
  'Follicular unit anatomy references.',
  'Hairline design educational materials.',
  'Documentation templates.',
  'Educational case studies.',
  'Follow-up worksheets.',
  'No recurring subscription.',
];

export const finalIncludes = [
  'Six specialized educational volumes.',
  'Five professional bonuses.',
  'Patient assessment frameworks.',
  'Follicular unit anatomy references.',
  'Hairline design educational materials.',
  'Donor area assessment resources.',
  'Documentation templates.',
  'Educational case studies.',
  'Follow-up worksheets.',
];

export const volumeTopics = [
  'Patient assessment.',
  'Follicular unit anatomy.',
  'Hairline design.',
  'Donor area assessment.',
  'Complications and safety education.',
  'Documentation and follow-up.',
];

export const beforeItems = [
  'Your hair transplant references are scattered across different files and materials.',
  'Finding a specific anatomical concept requires searching through multiple resources.',
  'You want a more organized framework for reviewing patient assessment considerations.',
  'Your hairline design references are difficult to compare in one place.',
  'Your documentation and follow-up materials are not always easy to locate.',
  'You want practical educational resources that are easy to revisit.',
];

export const afterItems = [
  'Six educational volumes organized around distinct topics.',
  'Structured references for studying follicular unit anatomy.',
  'Educational frameworks for reviewing patient assessment considerations.',
  'Organized materials for studying hairline design concepts.',
  'Documentation templates that can be adapted to your professional setting.',
  'Educational cases and worksheets for structured review.',
];

export const resources = [
  {
    title: 'Follicular Anatomy References',
    body: 'Visual study materials that organize information about hair follicles, follicular units, and scalp anatomy.',
  },
  {
    title: 'Patient Assessment Frameworks',
    body: 'Educational worksheets for organizing patient history, hair loss characteristics, relevant observations, and questions requiring further evaluation.',
  },
  {
    title: 'Hairline Design Reference Materials',
    body: 'Educational comparisons and worksheets for studying hairline configurations, facial proportions, and aesthetic considerations.',
  },
  {
    title: 'Clinical Documentation Templates',
    body: 'Resources for organizing assessment records, photographic documentation, and follow-up information.',
  },
  {
    title: 'Educational Case Studies',
    body: 'Hypothetical scenarios for reviewing hair restoration concepts, discussing relevant observations, and structuring professional learning.',
  },
];
